export default {
    url: '/add',
    template: `
        <div class="heading01">
            <h1>{{ 'courses.Add course' | translate }}</h1>
            <ul class="actions01" ng-if="false">
                <li>
                    <a
                        class="btn bordered02"
                        ng-click="vm.CourseService.openHistoricParticipationModal(vm.course)"
                        ng-if="vm.PrivilegeService.canManageOccurrences()">
                        {{ 'course.Add course participation history' | translate }}
                    </a>
                </li>
            </ul>
        </div>
        <div ng-if="vm.isArchived" class="alert alert-warn ng-scope">
        {{ 'course.Course is archived! No actions can be made while course is archived' | translate }}
        </div>

        <!-- Arrow step UI is removed because it's not used in the current design of creating course. -->
        <ui-view></ui-view>
    `,
    abstract: true,
    controller ($scope, CourseService, PrivilegeService) {
        this.$scope = $scope;
        this.CourseService = CourseService;
        this.PrivilegeService = PrivilegeService;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/add/index.js